import * as d3 from 'd3';
import { ChartDataArray } from '../data/ChartDataArray';
import { ChartRenderer } from './ChartRenderer';
import { DataRenderer } from './DataRenderer';

export class DetectionDateMarkerRenderer extends DataRenderer {
  private markerIndex: number | null = null;

  private focusRing?: d3.Selection<SVGCircleElement, unknown, null, undefined>;

  constructor(
    private gElement: d3.Selection<SVGGElement, unknown, null, undefined>,
    private marker: { color?: string; focusRingColor?: string },
    private removeOuterSpacing?: boolean
  ) {
    super();
  }

  public render(x: d3.ScaleBand<string>, y: d3.ScaleLinear<number, number>, data: ChartDataArray) {
    const series = data.getData();
    if (series.length === 0) {
      return;
    }

    const lastIndex = series.length - 1;
    const last = series[lastIndex];

    if (last.label == null || last.value == null) {
      return;
    }

    this.markerIndex = lastIndex;

    const cx = (x(last.label) ?? 0) + ChartRenderer.getBandSpacing(x, lastIndex, !!this.removeOuterSpacing);
    const cy = y(last.value);

    const group = this.gElement.append('g').attr('class', 'detection-date-marker').attr('aria-hidden', 'true');

    const markerColor = this.marker.color ?? '#000000';
    const ringColor = this.marker.focusRingColor ?? markerColor;

    this.focusRing = group
      .append('circle')
      .attr('class', 'detection-date-focus')
      .attr('cx', cx)
      .attr('cy', cy)
      .attr('r', 8)
      .attr('fill', '#FFFFFF')
      .attr('stroke', ringColor)
      .attr('stroke-width', 3)
      .attr('opacity', 0);

    group
      .append('circle')
      .attr('class', 'detection-date-dot')
      .attr('cx', cx)
      .attr('cy', cy)
      .attr('r', 4.5)
      .attr('fill', markerColor);
  }

  public switchHighlight(index: number, highlight: boolean) {
    if (this.markerIndex == null || !this.focusRing) {
      return;
    }

    const shouldShow = highlight && index === this.markerIndex;
    this.focusRing.attr('opacity', shouldShow ? 1 : 0);
  }
}
